import React, { useState, useEffect, useRef } from "react";
import bannerImg from "../assets/images/House5.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faArrowRightLong,
  faAward,
  faBath,
  faBed,
  faEnvelope,
  faLocationDot,
  faMagnifyingGlass,
  faPhone,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectFade, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import avatar1 from "../assets/images/avatar1.png";
import avatar2 from "../assets/images/avatar3.png";
import placeholder from "../assets/images/house-placeholder.webp";
import { Link } from "react-router-dom";
import imgs from "./temp.json";
import ReactImageGallery from "react-image-gallery";
import calc from "../assets/images/shutterstock_2489188913-min.jpg";
import report from "../assets/images/shutterstock_699442570-min.jpg";
import house from "../assets/images/shutterstock_617467400-min.jpg";
import constants from "../constants/constants";
import video from "../assets/images/1026290987-preview.mp4";
import video2 from "../assets/images/1099572741-preview.mp4";
import formattingFunctions from "../functions/formatting";
import houseInterior from "../assets/images/shutterstock_2304013113-min.jpg";
// import houseInterior from "../assets/images/stock-photo-luxury-hotel-bathroom-interior-with-bathtub-and-side-table-concrete-floor-bathing-space-in-modern-2467634645.jpg"
import Contact from "./contact.component";
import houseInterior2 from "../assets/images/shutterstock_1935730303-min.jpg";
import skyline from "../assets/images/shutterstock_2467634645-min.jpg";
import SEO, { pageSEO } from "../components/seo.component";
import isReactSnap from "../utils/isReactSnap";
import globalState from "../utils/globalState";
import { useUserParams } from "../hooks/useUserParams";
import DEMO_LISTINGS from "../constants/demoListings";

// Function to get image from assets/images folder based on ListingKey
function getListingImage(listingKey) {
  if (!listingKey) return placeholder;
  
  try {
    // Use require.context to get all images from the images folder
    const imageContext = require.context('../assets/images', false, /\.(jpg|jpeg|png|webp)$/i);
    const imageKeys = imageContext.keys();
    
    // Find images that contain the ListingKey in their filename
    const matchingImages = imageKeys.filter(key => {
      const fileName = key.toLowerCase();
      const listingKeyLower = listingKey.toLowerCase();
      return fileName.includes(listingKeyLower);
    });
    
    if (matchingImages.length === 0) {
      return placeholder;
    }
    
    // Prioritize "main photo" images, otherwise return the first match
    const mainPhoto = matchingImages.find(key => key.toLowerCase().includes('main photo'));
    if (mainPhoto) {
      return imageContext(mainPhoto);
    }
    
    // Return the first matching image
    return imageContext(matchingImages[0]);
  } catch (error) {
    console.error('Error loading listing image:', error);
    return placeholder;
  }
}

export default function Homepage() {
  const proxyUrl = "https://cors-anywhere.herokuapp.com/";
  const testimonials = [
    {
      quote:
        "He is really good sds sf sdf sfsdf sdfsf sdfsdf sf sdfs dfs fsd fsfd fsd fsdf sdfsfds sdfs fsf sdfs dfsfdsdf sdfdsfs fsdffsd sdfsdfsf sdfsdf sdfsfsdfsdf sdfsdf sdfsdfsdf sdfsdfsdf",
      name: "Larry Ross",
      image: avatar1,
    },
    { quote: "Best realtor ever", name: "Sylvia Jones", image: avatar2 },
  ];
  const contact = useRef();
  const temp = [
    { CityRegion: "Beaches", Bedrooms: 4, Bathrooms: 3, ListPrice: 999000 },
    { CityRegion: "Leslieville", Bedrooms: 4, Bathrooms: 3, ListPrice: 999000 },
    { CityRegion: "Danforth", Bedrooms: 4, Bathrooms: 3, ListPrice: 999000 },
    { CityRegion: "High Park", Bedrooms: 4, Bathrooms: 3, ListPrice: 999000 },
  ];

  const [listings, setListings] = useState(DEMO_LISTINGS);
  const [media, setMedia] = useState(imgs.thumbs.value);
  const [formatted, setFormatted] = useState({});
  const loaded = useRef(false);
  const loadedRef = useRef(false);
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const [videoState, setVideoState] = useState(1); // 1 for video1, 2 for video2

  const {
    getCurrentAgentName,
    getCurrentAgentTitle,
    getCurrentAgentNumber,
    getCurrentAgentEmail,
    getCurrentBrokerage,
    getCurrentQuote,
    getCurrentAbout,
    getCurrentHeadshot
  } = useUserParams();

  // Get userId from URL parameters
  const getURLParameters = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return {
      userId: urlParams.get('userId')
    };
  };

  // Refs for elements
  const video1Ref = useRef(null);
  const video2Ref = useRef(null);
  const topleftRef = useRef(null);
  const toprightRef = useRef(null);
  const bottomleftRef = useRef(null);
  const bottomrightRef = useRef(null);
  const rightRef = useRef(null);
  const leftRef = useRef(null);
  const slideRefs = useRef([]);

  const onWindowResize = () => {
    setWindowSize(window.innerWidth);
  };

  // Handle video switching
  useEffect(() => {
    const video1 = video1Ref.current;
    const video2 = video2Ref.current;

    if (!video1 || !video2) return;

    const handleVideo1End = () => {
      video2.play();
      setVideoState(2);
    };

    const handleVideo2End = () => {
      video1.play();
      setVideoState(1);
    };

    video1.addEventListener("ended", handleVideo1End);
    video2.addEventListener("ended", handleVideo2End);

    return () => {
      video1.removeEventListener("ended", handleVideo1End);
      video2.removeEventListener("ended", handleVideo2End);
    };
  }, []);

  // Handle scroll animations
  useEffect(() => {
    const handleScroll = () => {
      const isElementInView = (element) => {
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top >= 0 && rect.bottom <= window.innerHeight;
        }
        return false;
      };

      if (isElementInView(topleftRef.current)) {
        topleftRef?.current?.classList?.remove("w-0");
        topleftRef?.current?.classList?.add("w-half");
      }

      if (isElementInView(toprightRef.current)) {
        toprightRef?.current?.classList?.remove("w-0");
        toprightRef?.current?.classList?.add("w-half");
      }

      if (isElementInView(leftRef.current)) {
        setTimeout(() => {
          leftRef?.current?.classList?.remove("h-0");
          leftRef?.current?.classList?.add("h-full");
        }, 1000);
      }

      if (isElementInView(rightRef.current)) {
        setTimeout(() => {
          rightRef?.current?.classList?.remove("h-0");
          rightRef?.current?.classList?.add("h-full");
        }, 1000);
      }

      if (isElementInView(leftRef.current)) {
        setTimeout(() => {
          bottomleftRef?.current?.classList?.remove("w-0");
          bottomleftRef?.current?.classList?.add("w-half");
        }, 2500);
      }

      if (isElementInView(rightRef.current)) {
        setTimeout(() => {
          bottomrightRef?.current?.classList?.remove("w-0");
          bottomrightRef?.current?.classList?.add("w-half");
        }, 2500);
      }

      slideRefs.current.forEach((el) => {
        if (el && isElementInView(el)) {
          el?.classList?.remove("slide-left");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", onWindowResize);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", onWindowResize);
    };
  }, []);

  function getData() {
    // Skip API calls during static generation
    if (isReactSnap()) {
      return Promise.resolve({ value: [] });
    }

    var body = {
      url: `https://query.ampre.ca/odata/Property?$filter=(ListAgentKey eq '${constants.AGENT_ID}' and StandardStatus eq 'Active')&$orderby=OriginalEntryTimestamp desc,ListingKey&$top=12`,
      needAuth: true,
      bearerToken: constants.TOKEN,
    };

    return new Promise(async (resolve, reject) => {
      try {
        let request = `odata/Property(Q)$filter=(ListAgentKey(S)eq(S)\'${constants.AGENT_ID}\'(S)and(S)StandardStatus(S)eq(S)\'Active\')(A)$orderby=OriginalEntryTimestamp(S)desc,ListingKey(A)$top=12`;


        let data =
          constants.ENVIRONMENT === "production"
            ? await fetch(`https://${constants.DOMAIN}/api/${request}`)
            : await fetch(`http://${constants.URL}/metaGet`, {
              method: "POST",
              body: JSON.stringify(body),
              headers: {
                "Content-Type": "application/json",
              },
            });

        if (data.ok) {
          let res = await data.json();
          resolve(res);
        } else {
          reject("Failed to fetch data");
        }
      } catch (err) {
        reject(err);
      }
    });
  }

  function getMedia(listings) {
    // Skip API calls during static generation
    if (isReactSnap() || !listings || listings.length === 0) {
      return Promise.resolve({ value: [] });
    }

    // this is for development
    //var temp = `https://query.ampre.ca/odata/Media?$filter=(`

    // this is for production
    // var temp = `odata/Media?$filter=(`

    if (constants.ENVIRONMENT === "development") {
      var temp = `https://query.ampre.ca/odata/Media?$filter=ResourceRecordKey in (`;
      for (let l of listings) {
        temp = temp + "'" + l.ListingKey + "', ";
      }
      temp = temp.slice(0, -2);
      temp =
        temp +
        ") and ImageSizeDescription eq 'Medium' and PreferredPhotoYN eq true";
    } else {
      var temp = `odata/Media(Q)$filter=ResourceRecordKey(S)in(S)(`;
      for (let l of listings) {
        temp = temp + "'" + l.ListingKey + "',";
      }
      temp = temp.slice(0, -1);
      temp =
        temp +
        ")(S)and(S)ImageSizeDescription(S)eq(S)'Medium'(S)and(S)PreferredPhotoYN(S)eq(S)true";
    }
    var body = {
      url: temp,
      needAuth: true,
      bearerToken: constants.TOKEN,
      // Accept: 'application/json',
      // Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ2ZW5kb3IvdHJyZWIvNjUyMCIsImF1ZCI6IkFtcFVzZXJzUHJkIiwicm9sZXMiOlsiQW1wVmVuZG9yIl0sImlzcyI6InByb2QuYW1wcmUuY2EiLCJleHAiOjI1MzQwMjMwMDc5OSwiaWF0IjoxNzMwMjI1OTA1LCJzdWJqZWN0VHlwZSI6InZlbmRvciIsInN1YmplY3RLZXkiOiI2NTIwIiwianRpIjoiMGYyMjk3OTY1Y2NjN2U4MSIsImN1c3RvbWVyTmFtZSI6InRycmViIn0.BMvVrtwah8swIzW38UMs6yKF-HM4QO0bZu81blYx6J4'
    };

    return new Promise(async (resolve, reject) => {
      try {
        let data =
          constants.ENVIRONMENT === "production"
            ? await fetch(`https://${constants.DOMAIN}/api/${temp}`)
            : await fetch(`http://${constants.URL}/metaGet`, {
              method: "POST",
              body: JSON.stringify(body),
              headers: {
                "Content-Type": "application/json",
              },
            });

        if (data.ok) {
          let res = await data.json();
          resolve(res);
        } else {
          reject("Failed to fetch data");
        }
      } catch (err) {
        reject(err);
      }
    });
  }

  function formatMedia(media) {
    var temp = {};

    for (let img of media) {
      if (temp[img.ResourceRecordKey]) {
        temp[img.ResourceRecordKey] = [...temp[img.ResourceRecordKey], img];
      } else {
        temp[img.ResourceRecordKey] = [img];
      }
    }
    return temp;
  }

  // Function to fetch template settings from MongoDB
  const fetchTemplateSettings = async (userId) => {
    try {
      const apiKey = process.env.REACT_APP_API_KEY;
      const response = await fetch(`https://agent.proagentsolutions.com/MongoDB/GetTemplateSettingsByUserId?userId=${userId}&apiKey=${apiKey}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const templateSettings = await response.json();
      console.log('Template settings fetched:', templateSettings);
      
      // Update global state with template settings
      if (templateSettings) {
        // Extract data from templateSettings.data if it exists
        const settingsData = templateSettings.data || templateSettings;
        
        // Map template settings to userData format
        const mappedUserData = {
          userId: userId,
          agentName: settingsData.agentName || settingsData.AGENT_NAME,
          agentTitle: settingsData.agentTitle || settingsData.AGENT_TITLE,
          agentNumber: settingsData.agentNumber || settingsData.AGENT_NUMBER,
          agentEmail: settingsData.agentEmail || settingsData.AGENT_EMAIL,
          brokerage: settingsData.brokerage || settingsData.BROKERAGE,
          // Include any additional fields from templateSettings.data
          ...settingsData
        };
        
        // Set the mapped user data
        globalState.setUserData(mappedUserData);
        
        console.log('Template settings data:', settingsData);
        console.log('Template settings mapped to user data:', mappedUserData);
      }
      
      return templateSettings;
    } catch (error) {
      console.error('Error fetching template settings:', error);
      return null;
    }
  };

  useEffect(() => {
    if (!loaded.current) {
      // Get and store URL parameters
      const urlParams = getURLParameters();
      if (urlParams.userId) {
        // Set global userId
        globalState.setUserId(urlParams.userId);
        
        // Fetch additional template settings from MongoDB
        // This will also update userData and userParams cache
        fetchTemplateSettings(urlParams.userId).then(() => {
          // Debug information after template settings are loaded
          console.log('Global State Updated with Template Settings:', globalState.getDebugInfo());
        });
        
        // Debug information
        console.log('Global State Updated:', globalState.getDebugInfo());
      }

      var temp1 = [];
      getData()
        .then((data) => {
          const fetchedListings = data?.value ?? [];
          setListings(fetchedListings.length ? fetchedListings : DEMO_LISTINGS);
          getMedia(fetchedListings)
            .then((d) => {
              setMedia(d.value);
              temp1 = d.value;
              setFormatted(formatMedia(d.value));
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
          setListings(DEMO_LISTINGS);
        });

      // getMedia().then(data => {
      //     console.log(data)
      //     setMedia(data.value)

      // }).catch(err => {
      //     console.log(err);
      // })
      // var temp = {}

      // for (let img of temp1) {
      //     if (temp[img.ResourceRecordKey]) {
      //         temp[img.ResourceRecordKey] = [...temp[img.ResourceRecordKey], img]
      //     } else {
      //         temp[img.ResourceRecordKey] = [img]

      //     }
      // }
      // console.log(temp)
      // setFormatted(temp);
      loaded.current = true;
    }
  }, []);

  function slugify(str) {
    str = str.replace(/^\s+|\s+$/g, "");
    str = str.toLowerCase();
    str = str
      .replace(/[^a-z0-9 -]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
    return str;
  }

  const [keyword, setKeyword] = useState("");

  const seoConfig = pageSEO.home();

  return (
    <>
      <SEO {...seoConfig} />
      <div>
        <div className="h-full w-full absolute -z-50 top-0 overflow-clip">
          {/* Default Home Video */}
          {!(constants.HOME_VIDEO || constants.HOME_IMAGE) && (
            <>
              <video
                ref={video1Ref}
                className={`h-full w-full object-cover ${
                  videoState === 2 ? "hidden" : ""
                }`}
                autoPlay
                muted
              >
                <source src={video} type="video/mp4" />
              </video>
              <video
                ref={video2Ref}
                className={`h-full w-full object-cover ${
                  videoState === 1 ? "hidden" : ""
                }`}
                muted
              >
                <source src={video2} type="video/mp4" />
              </video>
            </>
          )}
          {/* Home Video or Image */}
          {constants.HOME_VIDEO ? (
            <video
              className="h-full w-full object-cover"
              autoPlay={true}
              muted
              loop
            >
              <source src={constants.HOME_VIDEO} type="video/mp4" />
            </video>
          ) : (
            <img
              src={constants.HOME_IMAGE}
              className="h-full w-full object-cover"
              alt="Home"
            />
          )}
        </div>
        <div
          style={{ backgroundColor: "rgb(0, 0, 0, .4)" }}
          className="w-full  min-h-[100vh] relative"
        >
          <div className="absolute bottom-10 right-10 text-end px-5">
            <h1 className="text-4xl libre py-12 text-white text-unset">
              Your Trusted Realtor
            </h1>
            <hr className="border-gradient-2 ml-10" />
            <h2 className="text-5xl libre py-12 text-white pl-32">
              Find Your Dream Home
            </h2>
            <Link to={"/listings"}>
              <button className="btn-secondary border-gradient-2">
                View Listings
              </button>
            </Link>
            {/* <button className="btn-secondary">Why Choose {constants.AGENT_NAME.split(' ')?.[0]}</button> */}
          </div>
        </div>

        <div className=" bg-logo-second w-full">
          {/* <h1 className="text-4xl text-white py-10 font-mont px-10 uppercase pt-14 max-w-[1700px] mx-auto">Featured Neighbourhoods</h1>

                <div className="grid min-[750px]:grid-cols-2 px-10 max-w-[1700px] mx-auto">
                    {constants.LOCATIONS.slice(0, 4).map((location) =>
                        <Link to={`location/${formattingFunctions.slugify(location.name)}`}>
                            <div className="h-[40vh] relative cursor-pointer overflow-hidden flex items-center justify-center">
                                <img className="absolute h-full  object-cover opacity-75 hover:opacity-50 w-full top-[50%] translate-y-[-50%] hover:scale-105 duration-500 " src={location.img} />
                                <h1 className="text-3xl  text-white py-8 font-mont px-10 uppercase z-10">{location.name}</h1>

                            </div>
                        </Link>
                    )}


                </div> */}
          <div
            className="px-10  min-[900px]:grid py-32 -z-10"
            style={{ gridTemplateColumns: "40% 60%" }}
          >
            <div className="flex items-center flex-col gap-y-4 z-20 relative">
              <div className="max-[450px]:w-[110%] absolute z-10 h-[40vh] w-[85%]  -mt-16 ">
                <div
                  ref={toprightRef}
                  className="g-right absolute w-0 left-[50%] h-[2px]  duration-1000"
                ></div>
                <div
                  ref={topleftRef}
                  className="g-left absolute w-0 right-[50%] h-[2px]  duration-1000"
                ></div>
                <div
                  ref={leftRef}
                  className="bg-[#81817f] absolute w-[2px] left-0 h-0  duration-2000"
                ></div>
                <div
                  ref={rightRef}
                  className="bg-[#5e658a] absolute w-[2px] right-0 h-0  duration-2000"
                ></div>
                <div
                  ref={bottomrightRef}
                  className="g-right absolute w-0 bottom-0 right-0 h-[2px]  duration-1000"
                ></div>
                <div
                  ref={bottomleftRef}
                  className="g-left absolute w-0 bottom-0 left-0 h-[2px]  duration-1000"
                ></div>
              </div>
              <div className="max-[450px]:max-w-[100%] max-w-[70%] lg:max-w-[20vw] max-h-[50vh]  aspect-[3/4] overflow-clip z-30 mx-4 mb-12">
                <img
                  src={getCurrentHeadshot()}
                  className="h-full w-full object-cover "
                />
              </div>
            </div>
            <div className="flex flex-col text-white text-xl  z-20 relative">
              <h1
                style={{ fontWeight: "100" }}
                className={`text-4xl  text-white pb-8  libre tracking-wide z-10 mb-3 ease-in-out duration-2000 slide-in ${
                  windowSize > 700 ? "slide-left" : ""
                }`}
              >
                Your Trusted Realtor
              </h1>

              {getCurrentAbout() ? (
                getCurrentAbout().split("<|>").map((p, index) => (
                  <p key={index} className="min-[900px]:pr-[30%]">
                    {p}
                    <br />
                    <br />
                  </p>
                ))
              ) : (
                <p>Coming Soon</p>
              )}
              <div className="flex gap-x-4">
                <Link className="btn-primary self-start mt-5 " to={"/about"}>
                  <button>Why Choose {getCurrentAgentName()?.split(" ")[0]}</button>
                </Link>
                <Link
                  className="btn-secondary self-start mt-5 border-gradient-2"
                  to={"/contact"}
                >
                  <button>Contact Me</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-logo-main">
          <div className="w-full pt-10 px-10  mx-auto ">
            <div
              style={{
                backgroundImage: `url(${skyline})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundAttachment: "fixed",
              }}
              className="min-h-[80vh] md:min-h-[600px] relative  "
            >
              <div
                style={{ backgroundColor: "rgb(0, 0, 0, .5)" }}
                className="absolute h-full w-full z-10"
              ></div>
              <div className="h-full w-full text-white absolute z-20 text-center flex justify-center flex-col items-center gap-10">
                <h1 className="text-5xl px-3 libre">
                  Luxury Living Taken to New Heights
                </h1>
                <p className=" text-xl px-10 max-w-[1400px]">
                  {getCurrentAgentName()} knows the downtown Toronto market like
                  no other. Let your realtor guide you on one of the most
                  important decisions you'll make.
                </p>
              </div>
            </div>
          </div>

          <div className="flex justify-between items-center pt-14 pb-10 px-10 gap-x-5 max-w-[1900px] mx-auto">
            <h1
              ref={(el) => slideRefs.current.push(el)}
              className={`text-4xl libre uppercase ease-in-out duration-2000 slide-in ${
                windowSize > 700 ? "slide-left" : ""
              }`}
            >
              Featured Listings
            </h1>
            <Link
              className="underline font-semibold underline-offset-4 whitespace-nowrap "
              to={"/listings"}
            >
              View All
            </Link>
          </div>
          <div
            style={{
              gridTemplateColumns: `repeat( auto-fit, minmax(${
                windowSize > 600 ? "450px" : "300px"
              }, 1fr) )`,
            }}
            className="grid px-10  gap-10 pb-10  max-w-[1900px] mx-auto"
          >
            {listings?.slice(0, 6)?.map((prop) => (
              <Link
                key={prop.ListingKey}
                className="w-full h-full"
                to={`/listing/${prop.ListingKey}`}
              >
                <div className="relative hover:bg-black w-full aspect-[7/8] sm:aspect-[4/3] overflow-hidden group">
                  {/* <img className="w-full h-full object-cover" src={formatted[prop.ListingKey]?.find((img) => img.Order === 0)?.MediaURL ?? formatted[prop.ListingKey]?.[0]?.MediaURL ?? placeholder} /> */}
                  <img
                    className="w-full h-full absolute object-cover  group-hover:opacity-50  duration-1000 group-hover:scale-105"
                    src={getListingImage(prop.ListingKey)}
                  />
                  <div className="absolute flex flex-col w-full h-full z-50 overlay py-4 justify-end gap-y-2">
                    <p
                      style={{ fontWeight: "200" }}
                      className="libre min-[900px]:text-[1.25em] text-[1.25em] text-white px-4"
                    >
                      <FontAwesomeIcon icon={faLocationDot} className="pr-3" />
                      {prop?.StreetNumber} {prop?.StreetName}{" "}
                      {prop?.StreetSuffix}
                    </p>

                    <p className="font-bold text-white text-2xl px-4">
                      {prop.CityRegion ?? prop.CrossStreet}
                    </p>
                    <hr className="border-gradient-2 duration-1000 w-[20%] group-hover:w-[50%] mx-4 my-2"></hr>
                    <div className=" whitespace-nowrap flex-wrap child:px-4  flex ">
                      <div className="border-r-[1px] border-white text-white text-2xl">
                        <span>${prop.ListPrice?.toLocaleString()}</span>
                      </div>
                      <div className="border-r-[1px] border-white text-white text-2xl">
                        <span>{prop.BedroomsTotal} Beds</span>
                      </div>
                      <div className="border-r-[1px] border-white text-white text-2xl">
                        <span>{prop.BathroomsTotalInteger} Baths</span>
                      </div>
                      <div className=" text-white text-2xl">
                        {prop?.LivingAreaRange ? prop.LivingAreaRange : "--"}{" "}
                        Sqft
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <div className="w-full bg-logo-second ">
          <div className="max-w-[1900px] mx-auto px-10 text-white pb-10">
            <h1
              className={`text-4xl py-12 libre ease-in-out duration-2000 slide-in ${
                windowSize > 700 ? "slide-left" : ""
              }`}
            >
              Useful Tools
            </h1>

            <div className="grid md:grid-cols-3 gap-10 child:overflow-hidden   mb-10">
              <Link className="group" to={"/calculator"}>
                <div className="overflow-hidden h-96">
                  <img
                    className="h-full w-full object-cover group-hover:scale-105 duration-700"
                    src={calc}
                  />
                </div>
                <hr className="border-gradient-2 duration-1000 w-[20%] group-hover:w-[50%] mt-6 my-2"></hr>

                <h3 className="text-2xl pt-2 pb-2 ">Mortgage Calculator</h3>
                <span className="">
                  Find a price range that works with your budget by using our
                  Mortgage Calculator
                </span>
              </Link>
              <Link className="group" to={"/real-estate-reports"}>
                <div className="overflow-hidden h-96">
                  <img
                    className="h-full w-full object-cover group-hover:scale-105 duration-700"
                    src={report}
                  />
                </div>
                <hr className="border-gradient-2 duration-1000 w-[20%] group-hover:w-[50%] mt-6 my-2"></hr>

                <h3 className="text-2xl pt-2 pb-2 ">Real Estate Reports</h3>
                <span className="">
                  Gain valuable insights into the market with our free Real
                  Estate Reports
                </span>
              </Link>
              <Link className="group" to={"/evaluation"}>
                <div className="overflow-hidden h-96">
                  <img
                    className="h-full w-full object-cover group-hover:scale-105 duration-700"
                    src={house}
                  />
                </div>
                <hr className="border-gradient-2 duration-1000 w-[20%] group-hover:w-[50%] mt-6 my-2"></hr>

                <h3 className="text-2xl pt-2 pb-2 ">Home Evaluation</h3>
                <span className="">
                  How much is your home worth in today's market? Find out with
                  our free Home Evaluation
                </span>
              </Link>
            </div>
          </div>
        </div>

        <Contact />
      </div>
    </>
  );
}
